import { isPresent } from '@ember/utils';
import PledgeModel from 'donor-elf-web/models/pledge';
import AbilitiesService from 'donor-elf-web/services/abilities';
import moment from 'moment';

export let pledgeFrequencyLabels: { [frequencyId: string]: string } = {
  1: 'Monthly',
  2: 'Bi-Monthly',
  3: 'Quarterly',
  4: 'Semi-Annual',
  5: 'Annual',
  6: 'One Time',
  7: 'Weekly',
};

export let pledgeMonthlyFrequency = 1;
export let pledgeOneTimeFrequency = 6;

export function calculateEndDateMonthsForOneTimePledge(args: {
  startDate: Date;
  endDate: Date | undefined;
}) {
  if (isPresent(args.endDate)) {
    let dateRangeMonthsApart = moment(args.endDate).diff(
      args.startDate,
      'months',
      true,
    );
    return Math.round(dateRangeMonthsApart);
  } else {
    return null;
  }
}

export function calculateEndDateForOneTimePledge(args: {
  startDate: Date;
  endDateMonths: number;
  hasYtdGoalType: boolean;
}) {
  return args.hasYtdGoalType
    ? null
    : moment(args.startDate)
        .add(Number(args.endDateMonths), 'month')
        .subtract(1, 'day')
        .toDate();
}

export function canEditPledge(
  pledge: PledgeModel,
  abilities: AbilitiesService,
) {
  if (abilities.hasAbility('edit_pledges')) {
    return true;
  }
  if (
    (pledge.isManual || pledge.isNew) &&
    abilities.hasAbility('edit_manual_pledges')
  ) {
    return true;
  }
  if (!pledge.isManual && abilities.hasAbility('edit_system_pledge_end_date')) {
    return true;
  }
  return false;
}
